import { FC, useMemo } from 'react';
import {
  Checkbox,
  Skeleton,
  Stack,
  TableCell,
  TableRow,
} from '@mui/material';
import { InsertDriveFileOutlined } from '@mui/icons-material';

const smallBoxWidth = 5;

type TaskTableSkeletonPropsType = {
  rowCount?: number;
  cellCount?: number;
  showCheckbox?: boolean;
};

export const TaskTableSkeleton: FC<TaskTableSkeletonPropsType> = ({
  rowCount = 5,
  cellCount = 3,
  showCheckbox = true,
}) => {
  const largeBoxWidth = useMemo(() => 100 / cellCount, [cellCount]);

  const mediumBoxWidth = useMemo(
    () =>
      (100 - largeBoxWidth - smallBoxWidth * (showCheckbox ? 2 : 1)) /
      cellCount,
    [cellCount, largeBoxWidth, showCheckbox]
  );

  return (
    <>
      {[...Array(rowCount)].map((_, index) => (
        <TableRow key={index} sx={{ '& > td': { py: 0.5, px: 1.25, height: 44 } }}>
          {showCheckbox && (
            <TableCell padding="checkbox" width={`${smallBoxWidth}%`}>
              <Checkbox size="small" color="primary" checked={false} disabled />
            </TableCell>
          )}
          <TableCell width={`${largeBoxWidth}%`}>
            <Stack direction="row" columnGap={1.25} alignItems="center">
              <InsertDriveFileOutlined
                fontSize="small"
                aria-hidden
                sx={{ color: 'text.disabled' }}
              />
              <Skeleton width="calc(100% - 50px)" />
            </Stack>
          </TableCell>
          {[...Array(cellCount)].map((_, index) => (
            <TableCell key={index} width={`${mediumBoxWidth}%`}>
              <Skeleton />
            </TableCell>
          ))}
          <TableCell width={`${smallBoxWidth}%`} align="right">
            <Stack direction="row" spacing={0.5} justifyContent="flex-end">
              <Skeleton variant="circular" width={24} height={24} />
              <Skeleton variant="circular" width={24} height={24} />
              <Skeleton variant="circular" width={24} height={24} />
            </Stack>
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};
